import { useLocation, useNavigate } from "react-router-dom";
import Tabs from "./Tabs";

const TabsNavigation = ({ children, tabRoutes, title = "", content = true }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeIndex = tabRoutes.findIndex((tab) => location.pathname === tab.path);

  return (
    <div className="flex flex-col space-y-4">
      <div className="text-lg xls:text-3xl text-bunker font-semibold">
        {title}
      </div>
      <Tabs
        items={tabRoutes}
        selectedIndex={activeIndex}
        setSelectedIndex={(i) => navigate(tabRoutes[i].path)}
        content={content}
      />
      <div className="mt-4 flex-grow">{children}</div>
    </div>
  );
};

export default TabsNavigation;
